jQuery(document).ready(function ($) {
  // Accordion
  $('.accordion-section, .faq-accordion-section, .left-right-accordion-section').each(function () {
    var $section = $(this);
    $section.find('.closet-header').first().addClass('active').next('.closet-content').slideDown();

    $section.find('.closet-header').click(function () {
      var $header = $(this);
      $header.toggleClass('active').next('.closet-content').slideToggle();
      $section.find('.closet-header').not($header).removeClass('active').next('.closet-content').slideUp();
    });
  });

  // // Read More / Read Less
  // $('.text-content').each(function () {
  //   var $this = $(this);
  //   var fullText = $this.html().trim();
  //   var shortText = fullText.length > 350 ? fullText.substring(0, 350) + '...' : fullText;

  //   $this.data('full-text', fullText);
  //   $this.data('short-text', shortText);

  //   $this.html(shortText);
  // });

  // $('.read-more-btn').on('click', function () {
  //   var btn = $(this);
  //   var content = btn.closest('.d-flex.flex-column').find('.text-content');

  //   if (btn.text().trim() === 'Read more') {
  //     content.html(content.data('full-text'));
  //     btn.text('Read less');
  //   } else {
  //     content.html(content.data('short-text'));
  //     btn.text('Read more');
  //   }
  // });

  // Read More / Read Less
  $('.text-content').each(function () {
    var $this = $(this);
    var fullText = $this.html().trim();

    // Check if text is longer than 350
    if (fullText.length > 350) {
      var shortText = fullText.substring(0, 350) + '...';

      $this.data('full-text', fullText);
      $this.data('short-text', shortText);

      $this.html(shortText);

      // Show the Read more button
      $this.closest('.d-flex.flex-column').find('.read-more-btn').show();
    } else {
      // Hide the Read more button if text is short
      $this.closest('.d-flex.flex-column').find('.read-more-btn').hide();
      $this.html(fullText);
    }
  });

  $('.read-more-btn').on('click', function () {
    var btn = $(this);
    var content = btn.closest('.d-flex.flex-column').find('.text-content');

    if (btn.text().trim() === 'Read more') {
      content.html(content.data('full-text'));
      btn.text('Read less');
    } else {
      content.html(content.data('short-text'));
      btn.text('Read more');
    }
  });

  // Optional: run your Accordion class if needed
  if (typeof Accordion !== 'undefined') {
    const accordion = new Accordion();
    accordion.init();
  }
});
